import axios from 'axios';
import ApiGet from '../../sections/mainheader/apiget';



class PostedFilterService {
    constructor(apiUrl) {
        this.GetApiUrl = apiUrl;
        this.GetDynamicUIList = () => (axios.get(`${this.GetApiUrl}DynamicUI/GetDynamicUIList`));
        this.GetDynamicUISearchControls = () => (axios.get(`${this.GetApiUrl}DynamicUI/GetDynamicUISearchControl`));

    }
}
export default ApiGet().then((apiUrl) => new PostedFilterService(apiUrl));
